// extracted by mini-css-extract-plugin
module.exports = {"EmptyBackArrowMenu":"TypeMenuContentBank_EmptyBackArrowMenu__1Iel3"};